import {useState} from "react";
import {storageFactory} from "factory/storageFactory";


const sessionStore = storageFactory(() => sessionStorage);
/**
 * @template T
 * @param {string} key
 * @param {T} initialValue
 * @param {Storage} storage
 * @returns {[T, React.Dispatch<React.SetStateAction<T>>]}
 */
export default function useStorageState(key, initialValue, storage = sessionStore) {
  const [_value, _setValue] = useState(() => {
    try {
      return storage.getItem(key)
        ? JSON.parse(storage.getItem(key))
        : initialValue;
    } catch (error) {
      return initialValue;
    }
  });

  const setValue = value => {
    try {
      _setValue(value);
      storage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.log(e);
    }
  };

  const resetState = () =>{
    storage.removeItem(key);
  }

  return [_value, setValue, resetState];
}